import EntityServise from './entityService'

class UnitService extends EntityServise {
    constructor(){
        super("unit")
    }
}

export default new UnitService();